export const RequestServiceCodeConstant = {
    CATEGORY: "Code",
    TITLE: "Request Service Code and Sub-Service Code",
    SERVICE_REQUEST_CODE: "Service Request Code",
    SUB_SERVICE_REQUEST_CODE: "Sub-Service Request Code",
    REMARK: "Remark",
    ACTIVE_IND: "Active Ind.",
}

export const ServiceRequestCodeRequiredFieldList: string[] = [
    'serviceRequestCode',
    'subServiceRequestCode',
    'activeInd',
];